import { useMemo } from 'react';
import { useABTestingConfig } from '@packages/shared';
import type { ImageCDNProvider } from '@packages/common';

import type { DyImages, DyImage } from '../types';
import { dyImageSrcToCdnImageSrc } from './dyImageSrcToCdnImageSrc';

export function useGetDyImageSources(images: DyImages): {
  sources: string[];
  cdnProvider?: ImageCDNProvider;
} {
  const { IMAGE_CDN_PROVIDER } = useABTestingConfig() || {};

  const { desktop, tablet, mobile } = images;
  const [mobileSrc, tabletSrc, desktopSrc] = useMemo(() => {
    const sources = [mobile, tablet, desktop];

    return sources.map((image: DyImage) => dyImageSrcToCdnImageSrc(image, IMAGE_CDN_PROVIDER));
  }, [IMAGE_CDN_PROVIDER, desktop, mobile, tablet]);

  return { sources: [mobileSrc, tabletSrc, desktopSrc], cdnProvider: IMAGE_CDN_PROVIDER };
}
